import React from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
// import Breadcrumb from 'react-bootstrap/Breadcrumb';
// import { LinkContainer } from 'react-router-bootstrap';
import { Helmet } from 'react-helmet';
import { XRPSCAN_API_URL } from '../../config';
import { handleResponse } from '../common/Helpers';
import BalanceInfo from './BalanceInfo';
import BalanceTable from './BalanceTable';
import Analytics from '../common/Analytics';
import XIcon from '../lib/XIcon';
import IntegrationGuide from '../common/IntegrationGuide';
import SponsorContainer from '../sponsorship/SponsorContainer';
import TextAd from '../sponsorship/TextAd';

class Balance extends React.Component {
	constructor() {
		super();

		this.state = {
			facts: {},
			objectCount: {},
			accountBalances: [],
			loading: false,
		}
	}

	componentDidMount() {
		this.fetchObjectCount();
		this.fetchFacts();
		this.fetchBalances();
		Analytics.pageview();
	}

  fetchFacts() {
		fetch(`${XRPSCAN_API_URL}/fact/XRP`)
			.then(handleResponse)
			.then((data) => {
				this.setState({
					facts: data,
				});
			})
			.catch(() => {
			});
	}

  fetchObjectCount() {
		fetch(`${XRPSCAN_API_URL}/fact/ObjectCount`)
			.then(handleResponse)
			.then((data) => {
				this.setState({
					objectCount: data,
				});
			})
			.catch(() => {
			});
	}

	fetchBalances() {
		this.setState({ loading: true });
		fetch(`${XRPSCAN_API_URL}/balances`)
			.then(handleResponse)
			.then((data) => {
				this.setState({ accountBalances: data });
			})
			.catch(() => {
			})
			.finally(() => {
				this.setState({ loading: false });
			});
	}

	render() {
		const {
			facts,
			objectCount,
			accountBalances,
			loading,
		} = this.state;

		return (
			<div>
				<Helmet>
					<title>XRP Rich list and balance distribution | XRPSCAN</title>
				</Helmet>
				<Row>
					<Col>
						<IntegrationGuide/>
					</Col>
				</Row>
				<Row>
					<Col xs={12} md={12}>
						<SponsorContainer />
					</Col>
				</Row>
				{/* <Row>
					<Col xs={12} md={12}>
						<Breadcrumb>
							<LinkContainer to={`/`}><Breadcrumb.Item>Home</Breadcrumb.Item></LinkContainer>
							<Breadcrumb.Item active>XRP distribution</Breadcrumb.Item>
						</Breadcrumb>
					</Col>
				</Row> */}
				<Row>
					<Col xs={12} md={12}>
						<BalanceInfo 
							facts={facts}
							objectCount={objectCount}
						/>
					</Col>
				</Row>
				<Row>
					<Col xs={12} md={12}>
						<TextAd/>
					</Col>
				</Row>
				<Row>
					<Col xs={12} md={12}>
						<Card>
							<Card.Body>
								<Card.Title>
									<XIcon icon='user' />
									<span className="pl-2">Top accounts by XRP balance</span>
								</Card.Title>
								<BalanceTable
									total_coins={Number(facts.total_coins)}
									accountBalances={accountBalances}
									loading={loading}
								/>
							</Card.Body>
						</Card>
					</Col>
				</Row>
			</div>
		);		
	}
}

export default Balance;